import { createUseStyles } from 'react-jss';

const styles = {
  commentStyle: {
    marginTop: '2%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    textAlign: 'justify'
  },
  truncateAndCollapse: {
    color: '#44c2fc !important',
    cursor: 'pointer',
    '&:hover': {
      color: '#87d9ff !important'
    }
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'CommentText'
});
